import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AdminPanelImageUploader } from '../admin-panel-image-uploader';
import { AdminPosterImageUploaderProps } from './admin-poster-image-uploader-props';
import { getImageUrl } from '../../../selectors/image';
import { uploadImageRequest } from '../../../actions/image';
import { uuid } from '@robotsnacks/uuid';

export const AdminPosterImageUploader: React.FunctionComponent<
  AdminPosterImageUploaderProps
> = props => {
  const {
    imageKey = '',
    onUploadStart,
    height,
    width,
    helperText,
    ...rest
  } = props;

  const dispatch = useDispatch();

  const url = useSelector(getImageUrl(imageKey));

  const [file, setFile] = useState<File | undefined>(undefined);

  const onFile = useCallback((file: File) => {
    const imageKey = uuid();
    setFile(file);
    dispatch(uploadImageRequest(imageKey, file));
    if (onUploadStart) {
      onUploadStart(imageKey);
    }
  }, []);

  return (
    <AdminPanelImageUploader
      file={file}
      height={height}
      helperText={helperText}
      onFile={onFile}
      url={url || undefined}
      width={width}
    />
  );
};
